module.exports = __webpack_public_path__ + "static/buxus-sempervirens-0-e85ea66905ea16724406ef05c72ac53f.png";